export enum AgentType {
  DirectAgent = 1,
  IndirectAgent = 2,
  BancaStaff = 3,
  BancaNonStaff = 4,
}

export enum AgentTypeName {
  Agent = 'Agent',
  Banca = 'Banca',
  DirectAgent = 'Direct',
  IndirectAgent = 'Indirect',
}
